import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=764e465c&scoped=true&"
import script from "./shipment.vue?vue&type=script&lang=js&"
export * from "./shipment.vue?vue&type=script&lang=js&"
import style0 from "./shipment.vue?vue&type=style&index=0&id=764e465c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e465c",
  null
  
)

export default component.exports